import { Tab } from '@headlessui/react';

import { childrenToArray } from '@/lib/utils';

import type { FunctionComponent, ReactNode } from 'react';
import type { TypeTabBodyProps } from './types';

export const TabBody: FunctionComponent<TypeTabBodyProps> = ({
  className = '',
  children,
}: TypeTabBodyProps): JSX.Element => {
  const arrayOfChildren: ReactNode[] = childrenToArray(children);
  const panels = arrayOfChildren.map((child: ReactNode, index: number) => (
    <Tab.Panel unmount={false} key={index}>
      {child}
    </Tab.Panel>
  ));

  return (
    <Tab.Panels className={`px-4 ${className}`}>
      <div className="border-b border-dashed border-primary-600 py-3 xs:py-10">
        {panels}
      </div>
    </Tab.Panels>
  );
};
